<template>
  <div class="subtitle-wrapper">
    {{subTitle}}
  </div>
</template>
<script>
export default {
  name: "subtitle",
  props: {
    subTitle: {
      type: String,
      default: '副标题'
    }
  }
}

</script>

<style scoped lang="scss">
.subtitle-wrapper {
  padding-left: 8px;
  position: relative;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.24px;
  line-height: 24px;
  color: rgba(35, 35, 35, 1);
  text-align: left;
  vertical-align: top;
}
.subtitle-wrapper:before {
  z-index: -1;
  position: absolute;
  bottom: 4px;
  left: 0;
  content: '';
  width: 16px;
  height: 12px;
  background-image: url("@/assets/images/sub_title_img.png");
  background-size: cover;
}

</style>